import styled, { css } from 'styled-components';
import theme from 'theme';

export const TextNoOverflow = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100px;
`;

export const Plank = styled.span<{
    colorType?: keyof typeof theme.branding;
    size?: 'small' | 'mid' | 'large';
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: white;
    ${({ theme, colorType = 'primary' }) => {
        switch (colorType) {
            default:
            case 'primary':
                return css`
                    border: 1px solid ${theme.branding.primary.main};
                    color: ${theme.branding.primary.main};
                `;
            case 'secondary':
                return css`
                    background-color: ${theme.branding.secondary.main};
                    color: white;
                `;
            case 'tertiary':
                return css`
                    background-color: ${theme.branding.tertiary.main};
                    color: white;
                `;
        }
    }};

    ${({ size = 'small' }) => {
        switch (size) {
            default:
            case 'small':
                return css`
                    padding: 5px;
                    height: max-content;
                    width: max-content;
                `;
            case 'mid':
                return css`
                    padding: 0;
                    height: 18px;
                    min-width: 20px;
                `;
            case 'large':
                return css`
                    padding: 0;
                    height: 18px;
                    min-width: 20px;
                `;
        }
    }};
`;
